"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendedSelfMulticall__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "containsBytecode",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockBasefee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getChainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "tryMulticall",
        outputs: [
            {
                internalType: "bool[]",
                name: "successes",
                type: "bool[]",
            },
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class ExtendedSelfMulticall__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.ExtendedSelfMulticall__factory = ExtendedSelfMulticall__factory;
//# sourceMappingURL=ExtendedSelfMulticall__factory.js.map